import Api from "api/Api";
import type { ApiResponse } from "./ApiResponses";
import type { AxiosPromise, AxiosResponse, CancelTokenSource } from "axios";
import type { DSLWidget } from "WidgetProvider/constants";
import axios from "axios";

export interface SavePageDraftRequest {
  pageId: string;
  dsl: DSLWidget;
}

class DraftApi extends Api {
  static url = "v1/page-draft";
  static pageUpdateCancelTokenSource?: CancelTokenSource = undefined;

  static async savePageDraft(
    request: SavePageDraftRequest,
  ): Promise<AxiosPromise<ApiResponse>> {
    if (DraftApi.pageUpdateCancelTokenSource) {
        DraftApi.pageUpdateCancelTokenSource.cancel();
    }
    DraftApi.pageUpdateCancelTokenSource = axios.CancelToken.source();
    return Api.post(
      `${DraftApi.url}?pageId=${request.pageId}`,
      { dsl: request.dsl },
      undefined,
      { cancelToken: DraftApi.pageUpdateCancelTokenSource.token },
    );
  }

  static async getPageDraft(
    pageId: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return Api.get(`${DraftApi.url}?pageId=${pageId}`);
  }

  static async restorePageDraft(
    pageId: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return Api.put(`${DraftApi.url}/rollback?pageId=${pageId}`);
  }

  static async deletePageDraft(
    pageId: string,
  ): Promise<AxiosPromise<ApiResponse>> {
    return Api.delete(`${DraftApi.url}?pageId=${pageId}`);
  }

}

export default DraftApi;
